import React, { useReducer} from 'react';
import sanityClient from '../../client';
import ContactContext from './contactContext';
import ContactReducer from './contactReducer';
import {CLEAR_ERRORS, ERROR, LOADING, SUBMIT_FORM} from "../types";

const ContactState = (props) => {
  const initialState = {
    contacts: null,
    error: null,
    loading: false
  }

  const [state, dispatch] = useReducer(ContactReducer, initialState)

  // methods
  const submitForm = async (data) => {
    setLoading();

    try {
      const res = await sanityClient.create(data)
      console.log(res)
      dispatch({
        type: SUBMIT_FORM,
        payload: res,
      })
    } catch (err) {
      dispatch({
        type: ERROR,
        payload: err
        //err.response.body.error.description
      })
    }
  }

  const setLoading = () => {
    dispatch({
      type: LOADING
    })
  }

  const clearErrors = () => {
    dispatch({
      type: CLEAR_ERRORS
    })
  }


  return (
    <ContactContext.Provider
      value={{
      contacts: state.contacts,
      error: state.error,
      loading: state.loading,
      submitForm,
      setLoading,
      clearErrors,
    }}
    >
      {props.children}
    </ContactContext.Provider>
  );
};

export default ContactState;